import { Controller } from "@hotwired/stimulus";

// Fills the message body from a selected template and renders a per-recipient
// preview. Place on the compose form so it can read the selected
// contacts/groups for realistic preview samples.
export default class extends Controller {
  static targets = ["select", "body", "previewOutput"];
  static values = { previewUrl: String };

  useTemplate() {
    // Bulk/single SMS have an editable body textarea to fill. The campaign form
    // has none — the selected template IS the message — so nothing is filled
    // there; its body is read from the selected option at preview time.
    if (!this.hasBodyTarget) return;
    const option = this.selectTarget.selectedOptions[0];
    if (!option || !option.value) return;
    this.bodyTarget.value = option.dataset.body || "";
    this.bodyTarget.dispatchEvent(new Event("input", { bubbles: true }));
  }

  // Body to preview: the editable textarea where present, else the body carried
  // on the selected template option.
  currentBody() {
    if (this.hasBodyTarget) return this.bodyTarget.value;
    const option = this.hasSelectTarget
      ? this.selectTarget.selectedOptions[0]
      : null;
    return option?.dataset.body || "";
  }

  async preview() {
    const form = new FormData();
    form.append("body", this.currentBody());
    this.checkedValues("group_ids[]").forEach((v) =>
      form.append("group_ids[]", v),
    );
    this.checkedValues("contact_ids[]").forEach((v) =>
      form.append("contact_ids[]", v),
    );

    const response = await fetch(this.previewUrlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": this.csrfToken() },
      body: form,
    });
    this.previewOutputTarget.innerHTML = await response.text();
  }

  checkedValues(name) {
    return Array.from(
      this.element.querySelectorAll(`input[name="${name}"]:checked`),
    ).map((cb) => cb.value);
  }

  csrfToken() {
    return document.querySelector('[name="csrf-token"]')?.content;
  }
}
